import { useToast } from 'context/tostifyContext';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useMangeProduct = () => {
  const [products, setProducts] = useState([]);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [openManageProductModal, setOpenManageProductModal] = useState(false);
  const [openProductDeleteModal, setOpenProductDeleteModal] = useState(false);

  const [openProductModal, setOpenProductModal] = useState(false);
  const [modalMode, setModalMode] = useState('edit');
  const [dropDownValues, setDropdownValues] = useState([]);
  // destinationName

  useEffect(() => {
    if (!openManageProductModal) {
      return;
    }
    const fetchDropdowns = async () => {
      try {
        const [destinationRes, productRes] = await Promise.all([
          customAxios.get('CRM/GetAllCustomerLocations', {
            headers: authHeader(),
          }),
          customAxios.get('/Ops/GetProducts', {
            headers: authHeader(),
          }),
        ]);

        setDropdownValues(prev => ({
          ...prev,
          // species: speciesRes.data,
          product: productRes.data,
          destinations: destinationRes.data,
        }));
      } catch (err) {
        console.log(err, 'Error in getting dropdown values');
      }
    };

    fetchDropdowns();
  }, [openManageProductModal]);

  const { showToast } = useToast();
  const dispatch = useDispatch();

  function handleManageProductClick(id) {
    setSelectedContractId(id);
    setOpenManageProductModal(true);
  }

  async function handleDeleteProduct(id) {
    if (!id) {
      showToast('Failed to delete product ');
      return;
    }

    try {
      dispatch({ type: FETCH_START });
      const res = await customAxios.post('/Ops/DeleteContractsProductDetails', { id: id }, { headers: authHeader() });

      if (res.status === 200) {
        const filterProducts = products.filter(products => products.id !== id);
        setProducts(filterProducts);
        showToast('Product deleted successfully.');
        setOpenProductDeleteModal(false);
        dispatch({ type: FETCH_SUCCESS });
      }
    } catch (err) {
      console.log(err, 'Failed to delete product');
      showToast('Failed to delete product');
      dispatch({ type: FETCH_ERROR, payload: err.message });
    }
  }

  const fetchProducts = useCallback(async () => {
    if (!selectedContractId) return;

    try {
      dispatch({ type: FETCH_START });

      const res = await customAxios.get(`/Ops/GetContractProductDestinations/${selectedContractId}`, {
        headers: authHeader(),
      });

      if (res.status === 200) {
        console.log('MANAGE PRODUCTS ====', res);
        setProducts(res.data);
        dispatch({ type: FETCH_SUCCESS });
      }
    } catch (err) {
      console.log('Error in fetching products:', err);
      dispatch({ type: FETCH_ERROR, payload: err.message });
      showToast('Failed to fetch product for contract');
    }
  }, [selectedContractId, dispatch, showToast]);

  useEffect(() => {
    if (!selectedContractId) return;
    fetchProducts();
  }, [selectedContractId]);

  async function handleSave(productData, mode) {
    const basePayload = {
      contractUniqueID: productData.contractUniqueID,
      productGroup: productData.productGroup,
      purchasePrice: productData.purchasePrice ?? 0,
      productSource: productData.productSource || '',
      estimatedQty: productData.estimatedQty ?? 0,
      destination: productData.destination,
      vatRate: productData.vatRate ?? 0,
      destinationSiteAssessmentID: productData.siteAssessmentId,
      priority: productData.priority,
    };

    if (mode === 'edit') {
      const editPayload = {
        id: productData.id,
        ...basePayload,
      };
      try {
        const res = await customAxios.post('/Ops/EditContractProductDetails', editPayload, { headers: authHeader() });

        if (res.status === 200) {
          setOpenProductModal(false);
          showToast('Product edited successfully ');
          fetchProducts();
        }
      } catch (err) {
        console.log(err, 'Error in product edit');
        showToast('Failed to Edit Product', 'error');
        setOpenProductModal(false);
      }
    }

    if (mode === 'add') {
      console.log(basePayload, 'add');
      try {
        const res = await customAxios.post('/Ops/AddContractProductDetails', basePayload, { headers: authHeader() });

        if (res.status === 200) {
          setOpenProductModal(false);
          showToast('Product Added successfully ');
          fetchProducts();
        }
      } catch (err) {
        console.log(err, 'Error in product Add');
        showToast('Failed to Add Product', 'error');
        setOpenProductModal(false);
      }
    }
  }

  return {
    openManageProductModal,
    setOpenManageProductModal,
    handleManageProductClick,
    products,
    handleDeleteProduct,
    openProductDeleteModal,
    setOpenProductDeleteModal,
    openProductModal,
    setOpenProductModal,
    modalMode,
    setModalMode,
    handleSave,
    dropDownValues,
  };
};

export default useMangeProduct;
